import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://dev-wms-api.overflowsolutions.com.au/", // replace with your backend URL
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;